import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppConfigService } from '../app-configuration/app-config.service';
import { map, Observable } from 'rxjs';
import { TableContext } from '../+state/filter.reducer';

export type TableColumnConfiguration = { tableContext: TableContext; hiddenColumns: string[] };
export type UserPreferences = {
  tableColumConfiguration: TableColumnConfiguration[];
};

@Injectable({ providedIn: 'root' })
export class UserPreferencesService {
  private http = inject(HttpClient);

  private fetchUserPreferences(): Observable<UserPreferences> {
    return this.http.get<UserPreferences>(`${AppConfigService.appConfiguration.apiUrl['userService']}/preferences`);
  }

  private updateUserPreferences(updatedTableConfiguration: TableColumnConfiguration[]): Observable<UserPreferences> {
    return this.http.put<UserPreferences>(`${AppConfigService.appConfiguration.apiUrl['userService']}/preferences`, {
      tableColumConfiguration: updatedTableConfiguration,
    });
  }

  getHiddenColumnsConfiguration(): Observable<TableColumnConfiguration[]> {
    return this.fetchUserPreferences().pipe(map(userPreferences => userPreferences.tableColumConfiguration));
  }

  updateHiddenColumnsConfiguration(
    updatedTableConfigurations: TableColumnConfiguration[]
  ): Observable<TableColumnConfiguration[]> {
    return this.updateUserPreferences(updatedTableConfigurations).pipe(
      map(userPreferences => userPreferences.tableColumConfiguration)
    );
  }
}
